import { useState } from "react";
import {
  ChatBubbleLeftEllipsisIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { PortfolioCommentSheet } from "./PortfolioCommentSheet";

interface Props {
  fundId: number;
  fundName: string;
  quarter: string;
  lastCommentMessage?: string | null;
  lastCommentUserName?: string | null;
  lastCommentUserEmail?: string | null;
  lastCommentAt?: string | null;
}

function formatDateShort(iso: string): string {
  return new Date(iso).toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
}

export function PortfolioCommentCell({
  fundId,
  fundName,
  quarter,
  lastCommentMessage,
  lastCommentUserName,
  lastCommentUserEmail,
  lastCommentAt,
}: Props) {
  const [open, setOpen] = useState(false);
  const hasComment = !!lastCommentMessage;
  const displayName = lastCommentUserName || lastCommentUserEmail || "";

  return (
    <>
      <div className="flex items-center gap-1 min-w-0 w-full">
        {hasComment ? (
          <button
            onClick={() => setOpen(true)}
            className="flex-1 min-w-0 text-left group"
          >
            <p className="truncate text-xs text-slate-700 group-hover:text-blue-600 leading-tight">
              {lastCommentMessage!.length > 55
                ? lastCommentMessage!.slice(0, 55) + "…"
                : lastCommentMessage}
            </p>
            <p className="text-[11px] text-slate-400 leading-tight mt-0.5">
              {displayName}
              {lastCommentAt ? ` · ${formatDateShort(lastCommentAt)}` : ""}
            </p>
          </button>
        ) : (
          <span className="flex-1 text-slate-300 text-xs">—</span>
        )}

        <div className="flex items-center shrink-0">
          {hasComment && (
            <button
              onClick={() => setOpen(true)}
              className="p-1 rounded text-slate-400 hover:text-slate-600 hover:bg-slate-100"
              title="View comments"
            >
              <ChatBubbleLeftEllipsisIcon className="w-3.5 h-3.5" />
            </button>
          )}
          <button
            onClick={() => setOpen(true)}
            className="p-1 rounded text-slate-400 hover:text-blue-600 hover:bg-blue-50"
            title="Add a comment"
          >
            <PlusIcon className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      <PortfolioCommentSheet
        open={open}
        onClose={() => setOpen(false)}
        fundId={fundId}
        fundName={fundName}
        quarter={quarter}
      />
    </>
  );
}
